import Image from '../../../components/Image';
import { cleanBookTitle } from '../../Homepage/Contexts/DiffitBooksContext';
import { ChapterDropdown } from './ChapterDropdown';

/**
 * Displays a book preview with cover art and chapter range dropdowns for selecting start and end chapters.
 * @param {Object} bookData - Book metadata including title, author, cover, and chapters.
 * @param {string[]} normalizedChapters - Array of chapter names derived from bookData.
 * @param {number} bookStartChapterIdx - Index of the selected start chapter (-1 if none).
 * @param {Function} setBookStartChapterIdx - Setter for the start chapter index.
 * @param {number} bookEndChapterIdx - Index of the selected end chapter (-1 if none).
 * @param {Function} setBookEndChapterIdx - Setter for the end chapter index.
 * @param {Array} bookStartChapterOptions - Filtered chapter options available for start selection.
 * @param {Array} bookEndChapterOptions - Filtered chapter options available for end selection.
 */
export const BookSelectionSection = ({
  bookData,
  normalizedChapters,
  bookStartChapterIdx,
  setBookStartChapterIdx,
  bookEndChapterIdx,
  setBookEndChapterIdx,
  bookStartChapterOptions,
  bookEndChapterOptions,
}) => (
  <div className='mb-8'>
    {/* Book Preview */}
    <div className='flex items-center gap-4 p-4 bg-gray-50 rounded-xl mb-6'>
      {bookData.cover && (
        <Image
          src={bookData.cover}
          alt={bookData.title}
          className='w-14 h-20 object-contain flex-shrink-0'
        />
      )}
      <div>
        <div className='font-medium text-gray-900 text-lg'>{cleanBookTitle(bookData.title)}</div>
        <div className='text-gray-500'>by {bookData.author}</div>
      </div>
    </div>

    {/* Chapter Selection */}
    <div className='grid grid-cols-2 gap-4'>
      <div>
        <label className='block text-sm font-medium text-gray-700 mb-2'>Start Chapter</label>
        <ChapterDropdown
          options={bookStartChapterOptions}
          selected={bookStartChapterIdx >= 0 ? normalizedChapters[bookStartChapterIdx] : ''}
          placeholder='Select chapter'
          onChange={(selected) => {
            const newIdx = selected.value - 1;
            setBookStartChapterIdx(newIdx);
            if (bookEndChapterIdx === -1) {
              setBookEndChapterIdx(newIdx);
            }
          }}
        />
      </div>

      <div>
        <label className='block text-sm font-medium text-gray-700 mb-2'>End Chapter</label>
        <ChapterDropdown
          options={bookEndChapterOptions}
          selected={bookEndChapterIdx >= 0 ? normalizedChapters[bookEndChapterIdx] : ''}
          placeholder='Select chapter'
          onChange={(selected) => {
            const newIdx = selected.value - 1;
            setBookEndChapterIdx(newIdx);
          }}
        />
      </div>
    </div>
  </div>
);
